<template>
  <div class="cash-register-page">
    <router-view/>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../cash-register.scss";
</style>
